.input-action-container {
  display: flex;

  .input-wrapper {
    background: var(--base_color2);
    padding: 0;
    flex: 1;
    display: flex;
    border-radius: 4px;

    &:focus-within {

      input,
      .icon-wrapper,
      .language-selector {
        border-color: var(--color_primary_500);
      }
    }

    input {
      border: 1px solid var(--gray_light1);
      border-left: 0;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      padding: 8px;
      display: block;
      width: 100%;
      box-sizing: border-box;
      color: var(--gray_dark2);
      margin: 0;
      &:disabled {
        background: var(--color_neutral_100);
      }
    }

    .language-selector {
      display: flex;
      border: 1px solid var(--gray_light1);
      border-right: none;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;

      .select-icon-group {
        border: none;
      }

      .icon-wrapper {
        border: none;
      }

      .filter {
        min-width: 140px;
        max-width: 160px;

        &>div {
          transition: all 0s;
          border: none;
          border-radius: 0;
          min-height: 42px;

          &>div:nth-child(2) {
            flex-direction: row-reverse;
          }
        }
      }
    }
  }

  .icon-wrapper {
    height: 38px;
    align-self: center;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    border: 1px solid var(--gray_light1);
    border-right: 0;
    padding-left: 8px;
    display: flex;

    .InputAction-icon {
      height: 40%;
      align-self: center;
      justify-self: center;
      rect {
        fill: none;
      }
    }
  }

  &.disabled {
    .icon-wrapper {
      background: var(--color_neutral_100);
    }
  }
}